import { RootState } from "../index";

export const sessionSelector = (state: RootState) => state.session;
